const routes = {
  users: () => '/system-configuration/users',
  usersItem: (id) => `/system-configuration/users/${id}`,
  tenantUsers: () => '/configuration/users',
  tenantUsersItem: (id) => `/configuration/users/${id}`,
  userProfile: () => '/profile'
};

export default routes;
